export enum MainDashBoardChart {
  SPENDING = "SPENDING",
  NET_BURN_AND_BALANCE = "NET_BURN_AND_BALANCE",
  NET_BURN = "NET_BURN",
  TODAY_CASH = "TODAY_CASH",
  REVENUE = "REVENUE",
  RUNWAY_RUN_RATE = "RUNWAY_RUN_RATE",
}
